import * as React from 'react';
import DOMPurify from 'dompurify';
import styled from 'styled-components';

import { COLORS } from '../../tokens/colors';
import { rem } from '../../tokens/spacing';

import { templateRichTextContentStyles } from './TemplateRichTextEditor.styled';

const StyledPreview = styled.div`
  border: 1px solid ${COLORS.LightGray};
  padding: ${rem(12)};
  min-height: ${rem(495)};
  max-height: ${rem(495)};
  overflow-y: auto;
  background: ${COLORS.White};
  border-radius: 0;
  ${templateRichTextContentStyles}
`;

export interface HtmlTemplatePreviewProps {
  html: string;
  className?: string;
  semanticId?: string;
}

export const HtmlTemplatePreview = React.forwardRef<HTMLDivElement, HtmlTemplatePreviewProps>(
  function HtmlTemplatePreview({ html, className, semanticId }, ref) {
    const safeHtml = React.useMemo(
      () => DOMPurify.sanitize(html ?? ''),
      [html],
    );

    return (
      <StyledPreview
        ref={ref}
        className={className}
        data-semantic-id={semanticId}
        dangerouslySetInnerHTML={{ __html: safeHtml }}
      />
    );
  },
);

HtmlTemplatePreview.displayName = 'HtmlTemplatePreview';
